import { createUseStyles } from 'react-jss'

export const carouselPadding = 10

export default createUseStyles({
  carousel: {
    display: 'flex',
    padding: carouselPadding,
    paddingTop: 0
  }
})
